import { render, staticRenderFns } from "./FlaggedBookings.vue?vue&type=template&id=c6bd53ac&"
import script from "./FlaggedBookings.vue?vue&type=script&lang=js&"
export * from "./FlaggedBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports